import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import classNames from "classnames";

import BackButton from "../components/layouts/BackButton";

// TODO: remove layouts/Header, check all Header usage
class Header extends Component {
  notificationClasses() {
    return classNames(
      'mobileNotifications',
      { " _newNotifications": this.props.unreadNotifications },
      {'_displayNone': !this.props.user.onboarding_finished},
    );
  }

  render() {
    if (!this.props.header && !this.props.backButtonAction && !this.props.backButtonLabel ) return <Fragment />;
    return (
        <div className="pageHeader">
          { this.props.backButtonAction &&
            <BackButton
              onClick={this.props.backButtonAction}
              label={this.props.backButtonLabel}
            />
          }
          {
            this.props.header &&
                <h2 className="headline">{this.props.header}</h2>
          }
        {
          this.props.user.id &&
            <a onClick={() => {this.props.push('/notifications')}} className={this.notificationClasses()}>
              <i className="materialIcon --small">notifications_none</i>
            </a>
        }
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    unreadNotifications: state.notifications.unreadNotifications,
    user: state.user,
  };
};


const mapDispatchToProps = (dispatch, props) => {
  return {
    push: (url) => {dispatch(push(url))},
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/features/shared/containers/Header.js